export const SET_COUNTRIES = 'SET_COUNTRIES'
export const REFRESH_COUNTRIES = 'REFRESH_COUNTRIES'
